/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { IUserProfile } from 'services/auth';

interface IUserSLiceState {
  userInfo: IUserProfile
}

const userSliceState: IUserSLiceState = {
  userInfo: {
    email: '',
    isAdmin: false,
    activedAt: '',
    updatedAt: '',
    createdAt: '',
    lastVisitedSiteId: '',
    name: '',
    username: '',
  },
};

export const userSlice = createSlice({
  name: 'user',
  initialState: userSliceState,
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
  },
});

export const { setUserInfo } = userSlice.actions;

export default userSlice.reducer;
